import { Toggle } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Toggle {
        togglingManually: boolean;
    }
}

// @ts-expect-error
const originalIToggle = Toggle.prototype._internalToggle;
// @ts-expect-error
Toggle.prototype._internalToggle = function internalToggle() {
    // Your custom logic here
    this.togglingManually = true;
    originalIToggle.call(this);
    this.togglingManually = false;
};

export {};
